import '../styles/NewOrder.scss';
import newOrder from '../assets/icons/new-order.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UniInput from '../components/UniInput/UniInput';
import { faCheck, faFileLines, faPen } from '@fortawesome/free-solid-svg-icons';
import { faCalendarXmark } from '@fortawesome/free-regular-svg-icons';
import { ChangeEvent, useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import UniModal from '../components/UniModal/UniModal';
import { useNavigate, useParams } from 'react-router-dom';
import { useUserStore } from '../store/user';
import { useTranslation } from 'react-i18next';
import { RequestOrderIntent, ResponseOrderIntent, getOrderIntent, putOrderIntentHistory } from '../services/orderService';
import { VeichleDescription, getVeichlesByMaterial } from '../services/veichleService';

type VeichleType = {
    description: VeichleDescription[],
    cod: string,
}

const EditOrder = () => {
    const [error, setError] = useState<string>();
    const [msgErrorDate, setErrorDate] = useState<string>('');
    const [showModalSucces, setShowModalSucces] = useState<boolean>(false);
    const [intents, setIntents] = useState<ResponseOrderIntent[]>([]);
    const [veichles, setVeichles] = useState<VeichleType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);
    const navigate = useNavigate();
    let { idGroup } = useParams();
    const { i18n, t } = useTranslation();
    const { loginData } = useUserStore();

    const backToList = () => {
        localStorage.setItem('backOffice_backToList', 'true');
        navigate('/home');
    }

    useEffect(() => {
        if (localStorage.getItem('tkn')) {
            getOrderIntent(1000, 1, '', '', idGroup ?? '', `1`, '', null)
                .then(r => {
                    if (r.success) {
                        setIntents(r.data);

                        getVeichlesByMaterial(r?.data?.[0]?.materialCode ?? ``, r?.data?.[0]?.incoterms ?? ``, r?.data?.[0]?.isPVC ?? false)
                        .then(v => {
                            let newVeichles: VeichleType[] = [];
                            v?.data?.forEach(d => {
                                console.log(d.veichleDescriptions)
                                let veichle: VeichleType = {
                                    cod: d.tm,
                                    description: d.veichleDescriptions
                                };

                                newVeichles.push(veichle);
                            });

                            setVeichles(newVeichles);
                        })
                        .catch(e => console.log(e))
                    }
                    else {
                        setError(r.error);
                    }
                })
                .catch(err => console.log(err))
                .finally(() => setLoading(false));
        }
    }, [loginData.id]);

    useEffect(() => {
        document.querySelectorAll("input[data-input='true']")?.forEach(el => {
            el?.setAttribute('disabled', 'true');
        });
    }, [document.querySelectorAll("input[data-input='true']")]);

    const onChangeUpdate = (e: ChangeEvent<HTMLInputElement>, id: string) => {
        const idx = intents.findIndex(d => d.id === id);
        if (idx > -1) {
            let intent = intents?.filter(d => d.id === id)[0];
            intent.update = e?.target?.checked;

            if (e?.target?.checked === true && intent.remove === true) {
                intent.remove = false;
            }

            setIntents([...intents]);
        }
    }

    const onChangeRemove = (e: ChangeEvent<HTMLInputElement>, id: string) => {
        const idx = intents.findIndex(d => d.id === id);
        if (idx > -1) {
            let intent = intents?.filter(d => d.id === id)[0];
            intent.remove = e?.target?.checked;

            if (e?.target?.checked === true && intent.update === true) {
                intent.update = false;
            }

            setIntents([...intents]);
        }
    }

    const updateIntents = async () => {
        const updatedIntents = intents.filter(i => i.update || i.remove);

        if (!updatedIntents) return;

        let body: RequestOrderIntent[] = [];

        updatedIntents?.map(u => {
            let newItem: RequestOrderIntent = {
                customerCode: u.customerCode,
                isRecused: u.remove,
                shipmentDate: u.shipmentDate ?? u.deliveryDate,
                shipmentQuantity: u.shipmentQuantity,
                veichleType: u.veichleType,
                veichleTypeName: u.veichleTypeName,
                recusedComment: u.recusedComment,
                orderItem: u.orderItem,
                orderMaterial: u.orderMaterial,
                orderNumber: u.orderNumber,
                id: u.id,
                unitMeasurement: `TO`,
                orderIntentGroupId: u.orderIntentGroupEntityId
            };

            body.push(newItem);
        })

        setLoadingUpdate(true);
        const result = await putOrderIntentHistory(body);
        setLoadingUpdate(false);

        if (!result.success) {
            setErrorDate(t('editOrder.msgErrorModified'));
        } else {
            setShowModalSucces(true);
        }
    }

    return (
        <>
            <div className='d-flex new-order-body'>
                <div className='new-order-content'>
                    <div className='new-order-content-header'>
                        <img src={newOrder} alt='icone de novo pedido'/>
                        <p>{t('editOrder.labelOrders')}</p>
                    </div>
                    {
                        loading ? (
                        <div className='w-100 d-flex align-items-center p-2'>
                            <Spinner />
                        </div>) :
                        (<>
                            <div className='new-order-content-from'>
                                <div>
                                    <p className='form-title'>
                                    {t('editOrder.labelOrderData')}
                                    </p>

                                    <div className='intent-info-group'>
                                        <div className='intent-info'>
                                            <label>{t('editOrder.labelClient')}</label>
                                            <p>{Number(intents?.[0]?.customerCode)}</p>
                                        </div>

                                        <div className='intent-info'>
                                            <label>{t('editOrder.labelReceiver')}</label>
                                            <p>{Number(intents?.[0]?.receiverCode)} - {intents?.[0]?.receiverName}</p>
                                        </div>

                                        <div className='intent-info'>
                                            <label>{t('editOrder.labelMaterial')}</label>
                                            <p>{Number(intents?.[0]?.materialCode)} - {intents?.[0]?.materialDescription}</p>
                                        </div>
                                    </div>

                                    <div className='intent-info-group'>
                                        <div className='intent-info'>
                                            <label>Incoterm</label>
                                            <p>{intents?.[0]?.incoterms}</p>
                                        </div>
                                        <div className='intent-info'>
                                            <label>{t('editOrder.paymentCondition')}</label>
                                            <p>{intents?.[0]?.paymentConditionDescription}</p>
                                        </div>
                                        {intents?.[0]?.deposit && <div className='intent-info'>
                                            <label>{t('editOrder.deposit')}</label>
                                            <p>{intents?.[0]?.deposit}</p>
                                        </div>}
                                    </div>

                                    <div className='divider'></div>
                                </div>

                                <div className='wrapper-body'>
                                    <p className='form-title'>
                                    {t('editOrder.labelOrders')}
                                    </p>

                                    {
                                        intents?.map(intent => (
                                            <div key={intent.intentNumber}>
                                                <div className='wrapper-delivery-form-body'>
                                                    <div className='body-key' title={t('editOrder.OrderPortal')}>
                                                        {intent.intentNumber}
                                                        <FontAwesomeIcon icon={faFileLines} style={{marginLeft: 10, height: 25}}/>
                                                    </div>
                                                    <div className='body-header'>
                                                        <label>{t('editOrder.labelDelivery')}</label>
                                                        <DatePicker
                                                            id='date-picker'
                                                            clearIcon={null}
                                                            calendarIcon={intent.update && !loadingUpdate ? (<FontAwesomeIcon icon={faPen} style={{height: 10}}/>) : (<div style={{display: 'none'}}></div>)}
                                                            dayPlaceholder=''
                                                            monthPlaceholder=''
                                                            yearPlaceholder=''
                                                            onChange={(e: any) => {
                                                                const date = new Date(e);
                                                                if (date) {
                                                                    if (date < new Date()) {
                                                                        setErrorDate(t('editOrder.errorDeliveryDatePast'));
                                                                    }
                                                                    else {
                                                                        intent.shipmentDate = date;
                                                                        setIntents([...intents])
                                                                    }
                                                                }
                                                            }}
                                                            closeCalendar
                                                            value={intent.shipmentDate ?? intent.deliveryDate}
                                                            minDetail='month'
                                                        />
                                                    </div>
                                                    <div>
                                                        <UniInput
                                                            label={t('editOrder.labelQtyMedia')}
                                                            type='number'
                                                            id='qtd-item'
                                                            placeholder={t('editOrder.labelQtyMedia')}
                                                            disabled={!intent.update || loadingUpdate}
                                                            value={intent.shipmentQuantity}
                                                            onChangeInput={(e) => {
                                                                if (Number(e?.target?.value) >= 0) {
                                                                    intent.shipmentQuantity = Number(e?.target?.value)
                                                                    setIntents([...intents])
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className='body-header'>
                                                        <UniInput
                                                            id='veichle'
                                                            label={t('editOrder.labelVehicle')}
                                                            type='select'
                                                            isSelect
                                                            placeholder={t('editOrder.labelVehicle')}
                                                            disabled={!intent.update || loadingUpdate}
                                                            onChange={e => {
                                                                const name = e?.target?.selectedOptions?.[0]?.text?.split(`-`)?.[1] ?? ``;
                                                                const type = e?.target?.value;

                                                                intent.veichleTypeName = name;
                                                                intent.veichleType = type;

                                                                setIntents([...intents])
                                                            }}
                                                        >
                                                            {
                                                                veichles?.map((v, idx) => (
                                                                    <option key={v.cod + idx} selected={v.cod === intent.veichleType}>
                                                                        {v.cod} - {v.description.filter(l => l.lang === i18n.language.toUpperCase())?.[0]?.description}
                                                                    </option>
                                                                ))
                                                            }
                                                        </UniInput>
                                                    </div>
                                                    <div className='body-remove'>
                                                        <Form.Check
                                                            type={'checkbox'}
                                                            id={`update`}
                                                            label={t('editOrder.labelChange')}
                                                            checked={intent.update}
                                                            onChange={e => onChangeUpdate(e, intent.id)}
                                                        />
                                                        <Form.Check
                                                            type={'checkbox'}
                                                            id={`remove`}
                                                            label={t('editOrder.labelRefuse')}
                                                            checked={intent.remove}
                                                            onChange={e => onChangeRemove(e, intent.id)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='wrapper-delivery-form-inputs'>
                                                    {
                                                        intent.incoterms === 'FOB' &&
                                                        <div>
                                                            <UniInput id='transp' label={t('editOrder.labelTransporter')} type='text' placeholder={t('editOrder.labelTransporter')} value={intent.transporterName ?? '-'} disabled/>
                                                        </div>
                                                    }
                                                    <div>
                                                        <UniInput id='numPed' label={t('editOrder.labelNumYourOrder')} type='text' placeholder='N do pedido' value={intent.orderNumber} disabled/>
                                                    </div>
                                                    <div>
                                                        <UniInput id='numMat' label={t('editOrder.labelNumYourMaterial')} type='text' placeholder={t('editOrder.labelNumYourMaterial')} value={intent.orderMaterial} disabled/>
                                                    </div>
                                                    <div>
                                                        <UniInput id='itemPed' label={t('editOrder.labelOrderItem')} type='text' placeholder={t('editOrder.labelOrderItem')} value={intent.orderItem} disabled/>
                                                    </div>
                                                </div>
                                                {
                                                    intent.remove && (
                                                        <div className='resume-obs'>
                                                            <Form.Group>
                                                                <Form.Label>{t('editOrder.labelAddRecuse')}</Form.Label>
                                                                <Form.Control as="textarea" rows={2} onChange={t => {
                                                                    intent.recusedComment = t?.target?.value;
                                                                    setIntents([...intents])
                                                                }} />
                                                            </Form.Group>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    intent.update && (
                                                        <div className='resume-obs'>
                                                            <Form.Group>
                                                                <Form.Label>{t('editOrder.labelAddAlter')}</Form.Label>
                                                                <Form.Control as="textarea" rows={2} onChange={t => {
                                                                    intent.recusedComment = t?.target?.value;
                                                                    setIntents([...intents])
                                                                }}/>
                                                            </Form.Group>
                                                        </div>
                                                    )
                                                }
                                                <div className='divider-body'></div>
                                            </div>
                                        ))
                                    }
                                    <div className='d-flex justify-content-end'>
                                        <Button variant='primary' onClick={backToList}>{t('user.labelBack')}</Button>&nbsp;
                                        <Button variant='primary' onClick={updateIntents} disabled={!intents?.some(i => i.update || i.remove) || loadingUpdate}>{t('editOrder.labelSaveChanges')}</Button>
                                    </div>
                                </div>
                            </div>
                        </>)
                    }
                </div>
            </div>
            <UniModal
                icon={faCheck}
                isFontAwsome
                iconColor='#00FF3C'
                title={intents?.some(i => i.update) ? t('editOrder.saveChangesMsgClient') : t('editOrder.saveChangesMsg')}
                message=''
                show={showModalSucces}
                onHide={() => {
                    setShowModalSucces(false);
                    navigate('/home');
                }}
                iconWidth={100}
                iconHeight={100}
            >
                <div className='modal-body-resume'>
                    <Button onClick={() => navigate('/home')}>{t('editOrder.backToChanges')}</Button>
                </div>
            </UniModal>

            <UniModal
                icon={faCalendarXmark}
                isFontAwsome
                title={t('editOrder.dateError')}
                message=''
                iconColor='#EA2027'
                show={msgErrorDate !== ''}
                onHide={() => {
                    setErrorDate('');
                }}
                iconWidth={200}
                iconHeight={200}
            >
                <div className='modal-body-resume'>
                    <p>{msgErrorDate}</p>
                    <Button onClick={() => setErrorDate('')}>{t('editOrder.ok')}</Button>
                </div>
            </UniModal>
        </>
    )
}

export default EditOrder;